import { render, staticRenderFns } from "./FormulateOskTextMask.vue?vue&type=template&id=57f19130&"
import script from "./FormulateOskTextMask.vue?vue&type=script&lang=js&"
export * from "./FormulateOskTextMask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57f19130')) {
      api.createRecord('57f19130', component.options)
    } else {
      api.reload('57f19130', component.options)
    }
    module.hot.accept("./FormulateOskTextMask.vue?vue&type=template&id=57f19130&", function () {
      api.rerender('57f19130', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/components/formulate/on-screen-keyboard/osk-text-mask/FormulateOskTextMask.vue"
export default component.exports